import axios from 'axios'
import { authHeader } from './services/base'
import React, { Suspense, useEffect } from 'react'
import { toast } from 'react-toastify'
import useGetUserInfo from 'src/hook/auth/useGetUserInfo'
import ConfigProviders from './components/ConfigProvider'
import PreLoading from './components/Loading'
import { useAppSelector } from 'src/hook'
import Login from './modules/login/login'
import { ReceiveTurnContextProvider } from './contexts/receiveTurnContext'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL

axios.interceptors.response.use(
  response => response,
  error => {
    try {
      const { status, data } = error.response

      switch (status) {
        case 400: {
          const err = (data.errors as string[]).join(',')
          toast.error(err)
          break
        }
        case 402: {
          const err = (data.errors as string[]).join(',')
          toast.warning(err)
          break
        }
        case 401: {
          toast.error('شما به این بخش دسترسی ندارید')
          break
        }
      }
    } catch {
      toast.error('خطا در ارتباط با سرور')
    }
    return Promise.reject(error)
  },
)
axios.interceptors.request.use(
  config => {
    config.headers = authHeader()
    return config
  },
  error => Promise.reject(error),
)

function App() {
  const { showLogin } = useAppSelector(state => state.common)
  const MainRoutes = React.lazy(() => import('src/Routes'))
  useGetUserInfo()
  return (
    <ReceiveTurnContextProvider>
      <Suspense fallback={<PreLoading position="fixed" />}>
        <ConfigProviders>
          {showLogin && <Login />}
          <MainRoutes />
        </ConfigProviders>
      </Suspense>
    </ReceiveTurnContextProvider>
  )
}

export default App
